import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/Home";
import BillsPage from "../pages/Bills";
import CreateBillPage from "../pages/Bills/create";
import PaymentsPage from "../pages/Payments";
import CreatePaymentPage from "../pages/Payments/create";
import SuppliersPage from "../pages/Suppliers";
import CreateSupplierPage from "../pages/Suppliers/create";
import ViewSupplierPage from "../pages/Suppliers/view";
import OrdersPage from "../pages/Orders";
import CreateOrderPage from "../pages/Orders/create";
import { PermissionRoute } from "../../../routes/PermissionRoute";

export default function PurchasesRoutes() {
  return(
    <Routes>
      <Route element={<PermissionRoute permission="purchases.home" />}>
        <Route path="home" element={<HomePage />} />
      </Route>

      <Route element={<PermissionRoute permission="purchases.bills.view" />}>
        <Route path="bills">
          <Route path="" element={<BillsPage />} />
          <Route path="create" element={<CreateBillPage />} />
          <Route path="edit/:id" element={<CreateBillPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="purchases.orders.view" />}>
        <Route path="purchase-orders">
          <Route path="" element={<OrdersPage />} />
          <Route path="create" element={<CreateOrderPage />} />
          <Route path="edit/:id" element={<CreateOrderPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="purchases.payments.view" />}>
        <Route path="payments">
          <Route path="" element={<PaymentsPage />} />
          <Route path="create" element={<CreatePaymentPage />} />
          <Route path="edit/:id" element={<CreatePaymentPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="purchases.suppliers.view" />}>
        <Route path="suppliers">
          <Route path="" element={<SuppliersPage />} />
          <Route path="create" element={<CreateSupplierPage />} />
          <Route path="view/:id" element={<ViewSupplierPage />} />
          <Route path="edit/:id" element={<CreateSupplierPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
